import React from 'react';
import {useField} from "formik";
import FloatingLabelField from "./FloatingLabelField";
import {DataRow} from "../layout";
import {User} from "fearless-common";
import {isInAdminEnvironment} from "../../utils/env";

export const customFieldsKeys = {
    studentNumber: 'student_number'
};

const userCustomFieldsLabelMapping = {
    [customFieldsKeys.studentNumber]: 'Student number'
}

export function getCustomFieldLabel(key: string) {
    return key in userCustomFieldsLabelMapping ? userCustomFieldsLabelMapping[key] : key;
}

/**
 * Show a list of input elements for the user custom fields.
 */
export default function UserCustomFields() {
    const [{ value: customFields }] = useField('custom_fields');

    return (
        <>
            {Array.isArray(customFields) && customFields.length > 0 ? customFields.map(({ name }, idx) => (
                <FloatingLabelField
                    key={name}
                    name={`custom_fields[${idx}][value]`}
                    label={getCustomFieldLabel(name)}
                />
            )) : (isInAdminEnvironment() && <i className="d-block neutral-400 py-3">No custom fields</i>)}
        </>
    );
}

export function ReadOnlyCustomFields({ customFields }: { customFields: User['custom_fields']}) {
    return (
        <>
            {customFields?.map(({ name, value }) => (
                <DataRow
                    key={name}
                    label={name in userCustomFieldsLabelMapping
                        ? userCustomFieldsLabelMapping[name] : name}
                >
                    {value}
                </DataRow>
            ))}
        </>
    );
}
